import { Grid } from "@mui/material";
import React from "react";
import { InputUploadFile, LinkFile } from "components/UI";
import { responseDownloadFileErrors, responseErrors } from "utils";
import { isUndefined } from "lodash";
import { TEMPLATE_NAME_UPLOAD } from "../constants/uploadRpkg";
import { useDownloadTemplateMutation } from "shared/services/inventory-forecast";
import { COMMON_ENUM, TEMPLATE_FILE_CODE } from "shared/constants";
import { useLoadingContext } from "shared/contexts/LoadingContext";

export default function HeaderSectionContainer({ form, setForm, setMsg: { setMsgError, setMsgAlert } }) {
  const { startLoading, stopLoading } = useLoadingContext();
  const exportTemplate = useDownloadTemplateMutation();
  // ? Upload File
  const uploadProcess = async (field, file, maxLength) => {
    try {
      setMsgAlert([]);
      setMsgError([]);
      if (isUndefined(file)) {
        setForm(prev => ({
          ...prev,
          file: {},
          fileName: "",
        }));
        return true;
      }

      setForm(prev => ({
        ...prev,
        file: file,
        fileName: file.name,
      }));
      return true;
    } catch (error) {
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  };

  const handleDownloadTemplate = async templateName => {
    try {
      setMsgAlert([]);
      const infoFile = TEMPLATE_FILE_CODE.find(v => v.value === templateName);
      // const fileName = infoFile?.fileName;
      const body = { dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM, cd: infoFile?.cd };
      startLoading();
      await exportTemplate(body);
      stopLoading();

      return true;
    } catch (error) {
      stopLoading();
      const msgError = responseDownloadFileErrors(error);
      setMsgError(msgError);
      return false;
    }
  };
  return (
    <Grid container spacing={2} sx={{ alignItems: "center" }}>
      <Grid item xs={12}>
        <strong>Please browse the Excel file, and click Upload button.</strong>
      </Grid>
      <Grid item xs={1}>
        <strong>*Excel File :</strong>
      </Grid>
      <Grid item xs={5}>
        <InputUploadFile
          id="input-upload-excel-container"
          fileType=".xlsx"
          required={true}
          onConfirmDelete={false}
          value={form?.file}
          uploadProcess={uploadProcess}
          maxLength={50}
          tabIndex={1}
        />
      </Grid>
      <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <LinkFile
          id={TEMPLATE_NAME_UPLOAD.CONT_STATUS}
          component="button"
          variant="body2"
          value={TEMPLATE_NAME_UPLOAD.CONT_STATUS}
          onClick={() => handleDownloadTemplate(TEMPLATE_NAME_UPLOAD.CONT_STATUS)}
          tabIndex={1}
        />
      </Grid>
      <Grid></Grid>
    </Grid>
  );
}
